export default __webpack_public_path__ + "09cffaf4b71adb51358c48eea2d4aba6.png";